export enum PriceCurrencySymbols {
  USDC = 'USDC',
  RMV = 'RMV',
  RLTM = 'RLTM',
  TRP = 'TRUMPET',
}
